import React from 'react'
import DeskDashboard from '../Components/DeskDashboard'
import { ESCALATED_KEY } from '../../lib/makerCheckerQueues'

// Escalation is national, so this queue deliberately skips buildOmmTabParams,
// which would scope a sales manager to their own branch.
function tabs() {
  return [
    {
      key: 'escalated',
      authorities: ['CAN_OMM_AML_MANAGEMENT'],
      label: 'Escalated Policies',
      params: {
        status: 'Un_Confirmed',
        additional_details: { [ESCALATED_KEY]: true }
      },
      emptyMessage: 'No policies have been escalated for review.',
      showAmlFlag: true,
      showStage: true,
      metricNote: 'Counted from when tracking went live (Nov 2026).'
    }
  ]
}

const ManagementDashboard = props => (
  <DeskDashboard
    {...props}
    title="Management"
    desk="management"
    tabs={tabs()}
  />
)

export default ManagementDashboard
